<div class="packages-block" [class.highlight]="highlight">
    <div class="packages-top-content">
        <div class="content-section">
            <span class="gm-name">{{ packageInfo.package_name }}</span>
        </div>
    </div>
    <div class="packages-bottom-content">
        <div class="content-info-panel">
            <div bgTimer class="timer">
                <i class="theme-clock-solid"></i>
                @if (packageInfo && packageInfo.start_time) {
                    <bg-schedule-timer [formatType]="2" [timerinput]="packageInfo.start_time" />
                }
            </div>
            <div class="info-panel-border"></div>
            <div class="discount">
                <span class="description">{{ content.Discountupto }} :</span>
                <span class="value"> {{ packageInfo.maximum_discount * 100 | number: '1.0-0' }} %</span>
            </div>
            <div class="info-panel-border"></div>
            <div class="info-icon" [ngClass]="isCozyUser ? 'cozy-icon' : ''" (click)="moreInfoClicked()">
                <div class="theme-info-i"></div>
            </div>
        </div>
        <div class="content-container">
            <div class="games">
                <div class="games-container">
                    <div class="game-icon-container">
                        <div class="game-icon"><span>B</span></div>
                        <span class="game-icon-content">GAMES</span>
                    </div>
                </div>
                <div class="game-count">{{ packageInfo.package_game_details.length }}</div>
            </div>
            <div class="tickets">
                <div class="ticket-icon" [ngClass]="isCozyUser ? 'theme-bingo-gala-ticket' : 'theme-bingo-ticket'"></div>
                <div class="ticket-price">
                    {{ packageInfo.minimum_price == null ? (0 | vnCurrency) : (totalCost || packageInfo.calculatedPriceFrom | vnCurrency) }}
                </div>
            </div>
            <div class="prize">
                <div class="trophy-icon" [ngClass]="isCozyUser ? 'theme-bingo-gala-trophy' : 'theme-bingo-trophy'"></div>
                <div class="prize-amount">{{ packageInfo.totalPrize == null ? (0 | vnCurrency) : (packageInfo.totalPrize | vnCurrency) }}</div>
            </div>
        </div>
        <div class="tickets-info-table">
            <div
                class="game-tickets-details"
                [ngClass]="{ 'session-purchased': packageInfo.staus_of_package == 'purchase' || packageInfo.staus_of_package == 'purchased' }">
                <div class="table-container">
                    <div class="container-columns">
                        <div class="container-block titles">
                            <div class="container-row">{{ content.Tickets }}</div>
                            <div class="container-row">{{ content.Discount }}</div>
                        </div>
                    </div>
                    @for (info of packageInfo.package_discount_info; track info; let i = $index) {
                        <div class="container-columns">
                            <div
                                class="container-block"
                                [ngClass]="{ selected: i == packageInfo.selectedDiscount, NotAllowed: info.Disabled }"
                                (click)="getCostSummary(info.number_of_tickets, info.discount, i)">
                                <div class="container-row">{{ info.number_of_tickets }}</div>
                                <div class="container-row">{{ info.discount * 100 | number: '1.0-2' }}%</div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
        <div class="bottom-content-container">
            <div class="package-cost">
                <div class="description">{{ content.PackageCost }} :</div>
                <div class="value">{{ totalCost | vnCurrency }}</div>
            </div>
            <div class="savings">
                <div class="description">{{ content.Savings }} :</div>
                <div class="value">{{ savings | vnCurrency }}</div>
            </div>
        </div>
        <!-- <div class="btn-section" *ngIf="!packageInfo.purchase_status?.no_of_tickets && packageInfo.staus_of_package == 'active'">
            <div class="buy-package-btn btn-primary btn" (click)="buyNowClicked()">
                {{ content.buy }}
            </div>
        </div>
        <div class="btn-section" *ngIf="packageInfo.staus_of_package == 'purchase'">
            <div
                class="buy-package-btn btn-primary btn"
                (click)="purchasedDetailClicked(packageInfo.packageId, packageInfo.purchase_status.no_of_tickets, packageInfo.staus_of_package)">
                {{ content.PurchaseButton }}
            </div>
        </div>
        <div class="btn-section" *ngIf="packageInfo.staus_of_package == 'purchased'">
            <div
                class="buy-package-btn btn-primary btn"
                (click)="purchasedDetailClicked(packageInfo.packageId, packageInfo.purchase_status.no_of_tickets, packageInfo.staus_of_package)">
                {{ content.PurchasedBtnText }}
            </div>
        </div> -->

        <div class="btn-section">
            <!-- @if (!packageInfo.packagePurchased) { -->
            <bg-custombutton
                *ngIf="!packageInfo.packagePurchased"
                [variant]="'filled'"
                [size]="'large'"
                [inverse]="true"
                [kind]="'primary'"
                [customClass]="'buy-session-btn btn-primary'"
                [button_text]="content.PurchaseButton"
                (click)="buyNowClicked()"
                >{{ content.PurchaseButton }}
            </bg-custombutton>
            <!-- } @else { -->
            <bg-custombutton
                *ngIf="packageInfo.packagePurchased"
                [variant]="'filled'"
                [kind]="'primary'"
                [size]="'large'"
                [customClass]="'buy-session-btn btn-primary disabled'"
                [button_text]="content.Purchased"
                >{{ content.Purchased }}
            </bg-custombutton>
            <!-- } -->
        </div>
    </div>
</div>
